'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextInput = function TextInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ['value', 'onChange']);

  return _react2.default.createElement('input', _extends({
    className: 'form-control',
    value: value || '',
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, rest));
};

exports.default = TextInput;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnB1dHMvVGV4dElucHV0LmpzIl0sIm5hbWVzIjpbIlRleHRJbnB1dCIsInZhbHVlIiwib25DaGFuZ2UiLCJyZXN0IiwiZSIsInRhcmdldCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFFQSxJQUFNQSxZQUFZLFNBQVpBLFNBQVksT0FBa0M7QUFBQSxNQUEvQkMsS0FBK0IsUUFBL0JBLEtBQStCO0FBQUEsTUFBeEJDLFNBQXdCLFFBQXhCQSxRQUF3QjtBQUFBLE1BQVhDLElBQVc7O0FBQ2xELFNBQ0U7QUFDRSxlQUFVLGNBRFo7QUFFRSxXQUFPRixTQUFTLEVBRmxCO0FBR0UsY0FBVTtBQUFBLGFBQUtDLFVBQVNFLEVBQUVDLE1BQUYsQ0FBU0osS0FBbEIsQ0FBTDtBQUFBO0FBSFosS0FJTUUsSUFKTixFQURGO0FBUUQsQ0FURDs7a0JBV2VILFMiLCJmaWxlIjoiVGV4dElucHV0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5jb25zdCBUZXh0SW5wdXQgPSAoeyB2YWx1ZSwgb25DaGFuZ2UsIC4uLnJlc3QgfSkgPT4ge1xuICByZXR1cm4gKFxuICAgIDxpbnB1dFxuICAgICAgY2xhc3NOYW1lPVwiZm9ybS1jb250cm9sXCJcbiAgICAgIHZhbHVlPXt2YWx1ZSB8fMKgJyd9XG4gICAgICBvbkNoYW5nZT17ZSA9PiBvbkNoYW5nZShlLnRhcmdldC52YWx1ZSl9XG4gICAgICB7Li4ucmVzdH1cbiAgICAvPlxuICApXG59XG5cbmV4cG9ydCBkZWZhdWx0IFRleHRJbnB1dCJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@geopagos/gp-forms/lib/inputs/TextInput.js
// module id = 88
// module chunks = 0